export default "__VITE_ASSET__DyIm6REr__"